// Eine gemeinsame Regel für das automatische Neuladen nach einem Chunk-Ladefehler
// (nach einem Deploy sind alte Chunks weg). Handler (main.tsx) und Fehlergrenze
// (App.tsx) fragen beide hier — zwei getrennte Regeln ließen sich gegenseitig
// aushebeln und ergaben eine Neuladeschleife. Höchstens ein automatisches
// Neuladen je 5 Minuten und Tab.

const MERKER_SCHLUESSEL = 'chunk-reload';
const SPERRE_MS = 5 * 60 * 1000;

export function darfAutomatischNeuladen(): boolean {
  try {
    const jetzt = Date.now();
    const gespeichert = sessionStorage.getItem(MERKER_SCHLUESSEL);
    if (gespeichert) {
      const letztes = Number(gespeichert);
      const differenz = jetzt - letztes;
      // Unlesbar (NaN) oder Zeitstempel in der Zukunft (Uhr zurückgestellt) gilt als abgelaufen.
      if (Number.isFinite(differenz) && differenz >= 0 && differenz < SPERRE_MS) {
        return false;
      }
    }
    sessionStorage.setItem(MERKER_SCHLUESSEL, String(jetzt));
    return true;
  } catch {
    // Ohne nutzbaren sessionStorage kein Merker -> lieber nicht neu laden als in eine Schleife geraten.
    return false;
  }
}
